<template>
  <div class="clientInformationForm">
    <el-form ref="form" label-width="100px" inline @submit.native.prevent style="width: 100%;">
      <div style="display: flex; flex-wrap: wrap;">
        <el-form-item label="客户姓名">
          <el-input v-model="searchParams.name" placeholder="请输入客户名称" @keyup.enter.native="queryData(1)" clearable
          @input="queryData(1)"></el-input>
        </el-form-item>
        <el-form-item label="渠道">
          <el-select v-model="searchParams.channel" placeholder="全部" collapse-tags clearable multiple filterable
            @change="queryData(1)"
          >
            <template v-for="item in channelOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道经理">
          <el-select v-model="searchParams.channelManager" placeholder="全部" collapse-tags clearable multiple filterable
            @change="queryData(1)"
          >
            <template v-for="item in channelManagerOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="是否参会">
          <el-select v-model="searchParams.attend" placeholder="全部" collapse-tags clearable multiple filterable @change="queryData(1)">
            <template v-for="item in constants.allAttendOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="是否住宿">
          <el-select v-model="searchParams.accomodation" placeholder="全部" collapse-tags clearable multiple filterable @change="queryData(1)">
            <template v-for="item in constants.AccomodationOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="是否晚宴">
          <el-select v-model="searchParams.dinner" placeholder="全部" collapse-tags clearable multiple filterable @change="queryData(1)">
            <template v-for="item in constants.DinnerOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="接机/站安排">
          <el-select v-model="searchParams.receive" placeholder="全部" collapse-tags clearable multiple filterable @change="queryData(1)">
            <template v-for="item in constants.ReceiveOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="送机/站安排">
          <el-select v-model="searchParams.send" placeholder="全部" collapse-tags clearable multiple filterable @change="queryData(1)">
            <template v-for="item in constants.ReceiveOptions">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="房型">
          <el-select v-model="searchParams.room" placeholder="全部" collapse-tags clearable multiple filterable @change="queryData(1)">
            <template v-for="item in ROOM_TYPE_LIST">
              <el-option :label="item.label" :value="item.value" :key="item.label">
              </el-option>
            </template>
          </el-select>
        </el-form-item>
      </div>

      <el-form-item style="text-align: right; width: 100%">
        <!-- <el-button @click="queryData(1)">查询</el-button> -->
        <el-button @click="onClear">重置</el-button>
        <el-button @click="exportData">导出问卷记录</el-button>
        <el-button @click="sendResultEmail" :loading="resultEmailLoading">发送问卷记录</el-button>
      </el-form-item>
    </el-form>
    <div style="flex: 5;overflow: auto" v-loading="loading">
      <div style="text-align: right;margin-top: 5px;font-weight: bold;">人数：{{ total }}</div>
      <el-table :data="tableData" border style="width: 100%"
        height="calc(100vh - 355px)"
        @sort-change="oneSortMethod"
        ref="tableRef"
      >
        <el-table-column label="序号" prop="index" fixed width="80">
        </el-table-column>
        <el-table-column label="渠道" prop="channel" fixed width="120">
        </el-table-column>
        <el-table-column label="分支" prop="branch" fixed width="120">
        </el-table-column>
        <el-table-column label="职位" prop="position" fixed width="100">
        </el-table-column>
        <el-table-column label="客户姓名" fixed width="160">
          <template slot-scope="scope">
            <span>{{ `${scope.row.name}${scope.row.nameRepeat && scope.row.phone ? scope.row.phone : ''}` }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="item in columns"
          :key="item.prop"
          :label="item.label"
          :prop="item.prop"
          :sortable="item.sortable"
          :width="item.width || 160"
        />
        <el-table-column label="更新时间" prop="_createTime" width="160" />
        <el-table-column label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <div style="display: flex;justify-content: flex-end;align-items: center;">
              <el-button class="table-button" @click="toggleEdit(scope.row)">{{ scope.row.attend === constants.Attend02 ? '新增问卷' : '编辑' }}</el-button>
              <el-button v-if="scope.row.attend !== constants.Attend02" @click="showHistoryInfos(scope.row)" class="table-button">查看</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          @current-change="queryDataByPage"
          @size-change="handleSizeChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next"
          :total="total">
      </el-pagination>

    </div>
    <el-dialog title="历史记录" :visible.sync="historyInfosShow" width="100%" @close="historyData = []">
      <el-table :data="historyData" border style="width: 100%" height="500px">
        <template v-for="item in columns">
          <el-table-column :key="item.prop" :label="item.label" :prop="item.prop" :width="item.width || 160">
          </el-table-column>
        </template>
        <el-table-column label="更新时间" prop="updateTime" width="160">
        </el-table-column>
      </el-table>
    </el-dialog>
    <AddOrUpdateQuestion :visible.sync="editVisible" :values="editFrom" @onSuccess="onSuccess"/>
  </div>
</template>

<script>
import {clientHistoryQuery, resultQuery, getQueryChannel, getQueryChannelManager, sendResultEmail} from '@/service/adminApis'
import {concatUrl} from "@/service/base";
import AddOrUpdateQuestion from '@/pages/admin/AddOrUpdateQuestion'
import { ROOM_TYPE_LIST } from '@/common/index';
import { getItem } from '@/util/index';
import {
  AttendKeys,
  AttendOptions,
  StationKeys,
  StationOptions,
  DinnerKeys,
  DinnerOptions,
  TransportKeys,
  TransportOptions,
  AccomodationMap,
  AccomodationOptions,
  ReceiveKeys,
  ReceiveOptions,
  Receive01,
  EventId as eventId,
  Attend02
} from '@/util/constants'
import moment from 'moment'
import lodash from 'lodash'
import { localCache } from '@gyasset/shared/utils';

export default {
  name: "clientInformationForm",
  components: {AddOrUpdateQuestion},
  data() {
    return {
      ROOM_TYPE_LIST,
      resultEmailLoading: false,
      searchParams: {
        name: "",
        channel: [],
        channelManager: [],
        attend: [],
        accomodation: [],
        dinner: [],
        receive: [],
        send: [],
        sortColumn: '',
        order: '',
      },
      tableData: [],
      columns: [
        {prop: 'channelManager', label: "渠道经理"},
        {prop: '_attend', label: "是否参会", width: 100},
        {prop: '_accomodation', label: "住宿安排"},
        {prop: '_room', label: "房型安排"},
        {prop: '_dinner', label: "是否晚宴", width: 80},
        {prop: '_receive', label: "接机/站安排", width: 100},
        {prop: 'receivePhone', label: "接机联系电话", width: 120},
        {prop: '_receiveStation', label: "到达站点", width: 208},
        {prop: 'receiveNumber', label: "航班号/车次", width: 100},
        {prop: 'receiveTime', label: "到达时间", width: '138', sortable: 'custom'},
        {prop: 'receiveCompany', label: "同行人" },
        {prop: '_send', label: "送机/站安排", width: 120},
        {prop: 'sendPhone', label: "送机联系电话", width: 120},
        {prop: '_sendStation', label: "出发站点", width: 208},
        {prop: 'sendTime', label: "酒店出发时间", width: '138', sortable: 'custom'},
        {prop: 'phone', label: "手机号", width: 120},
        {prop: 'remark', label: "备注", width: 180},
      ],
      historyInfosShow: false,
      historyData: [],
      pageSize: 30,
      currentPage: 0,
      total: 0,
      editVisible: false,
      editFrom: {},
      constants: {
        allAttendOptions: AttendOptions,
        AttendOptions: AttendOptions.filter(item => item.value !== Attend02),
        StationOptions,
        DinnerOptions,
        TransportOptions,
        AccomodationOptions,
        ReceiveOptions,
        Receive01,
        Attend02
      },
      channelOptions: [],
      channelManagerOptions: [],
      loading: true
    }
  },
  methods: {
    oneSortMethod({column, prop, order }){
      this.searchParams.sortColumn = prop;
      this.searchParams.order = order;
      this.queryData(1)
      console.log(column, prop, order, 'column, prop, order=========')
    },
    toggleEdit(row) {
      this.editFrom = {...row}
      this.editVisible = true
    },
    onSuccess() {
      this.queryData(1)
    },
    queryDataByPage(page) {
      this.currentPage = page
      this.queryData()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryDataByPage(1);
    },
    onClear() {
      const newSearchParams = {...this.searchParams}
      for (const argumentsKey in this.searchParams) {
        newSearchParams[argumentsKey] = ['name', 'sortColumn', 'order'].includes(argumentsKey) ? '' : []
      }
      this.$refs.tableRef.clearSort();
      this.searchParams = newSearchParams
      this.queryData(1)
    },
    async queryData(page) {
      this.loading = true
      try {
        if (page) {
          this.currentPage = page
        }
        let res = await resultQuery({...this.searchParams, pageSize: this.pageSize + "", offset: this.currentPage - 1})
        if (res) {
          let {code, msg, resultDetails, total} = res
          if (code === '0') {
            const newData = resultDetails && Array.isArray(resultDetails) ? resultDetails.map((item, index) => {
              return {
                ...item,
                index: (this.pageSize * (this.currentPage - 1)) + (index + 1),
                _createTime: item.createTime ? moment(new Date(item.createTime)).format('YYYY-MM-DD HH:mm:ss') : '',
                _accomodation: item.accomodation ? AccomodationMap[item.accomodation] : '',
                _attend: item.attend ? AttendKeys[item.attend] : "",
                _dinner: item.dinner ? DinnerKeys[item.dinner] : "",
                _receive: item.receive ? ReceiveKeys[item.receive] : "",
                _receiveTransport: item.receiveTransport ? TransportKeys[item.receiveTransport] : "",
                _receiveStation: item.receiveStation ? StationKeys[item.receiveStation] : "",
                _send: item.send ? ReceiveKeys[item.send] : "",
                _sendTransport: item.sendTransport ? TransportKeys[item.sendTransport] : "",
                _sendStation: item.sendStation ? StationKeys[item.sendStation] : "",
                _room: item.room ? getItem(ROOM_TYPE_LIST, item.room) : '',
              }
            }) : []
            this.tableData = [...newData]
            this.total = total
          } else {
            this.tableData = []
            this.total = 0
            this.$message.error(msg || "服务异常，请联系客服")
          }
        }
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    async sendResultEmail() {
      try {
        this.resultEmailLoading = true;
        const res = await sendResultEmail({...this.searchParams, eventId});
        if (res.code === '0') {
          this.$message.success('操作成功')
        } else {
          this.$message.error('操作失败')
        }
      } finally {
        this.resultEmailLoading = false;
      }
    },
    exportData: lodash.debounce(async function () {
      let response = await fetch(concatUrl(`/user/resultExport`), {
        method: 'POST',
        body: JSON.stringify({...this.searchParams, eventId}),
        credentials: 'include',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'token': localCache.get('token'),
        }
      })
      let fileName = "问卷记录"
      fileName = decodeURI(fileName)
      const blob = await response.blob() //返回完整的二进制数据
      // 创建下载的链接
      let downloadElement = document.createElement('a');
      let href = window.URL.createObjectURL(blob);
      downloadElement.href = href;
      downloadElement.download = fileName;
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
      // 释放掉blob对象
      window.URL.revokeObjectURL(href);
    }, 300),
    async showHistoryInfos(row) {
      this.historyInfosShow = true
      this.historyData = []
      let res = await clientHistoryQuery(row.clientId)
      if (res) {
        let {code, msg, resultDetails} = res
        if (code === '0') {
          const newData = resultDetails && Array.isArray(resultDetails) ?
              resultDetails.map(item => {
                return {
                  ...item,
                  updateTime: item.createTime ? moment(new Date(item.createTime)).format('YYYY-MM-DD HH:mm:ss') : '',
                  _accomodation: item.accomodation ? AccomodationMap[item.accomodation] : '',
                  _attend: item.attend ? AttendKeys[item.attend] : "",
                  _dinner: item.dinner ? DinnerKeys[item.dinner] : "",
                  _receive: item.receive ? ReceiveKeys[item.receive] : "",
                  _receiveTransport: item.receiveTransport ? TransportKeys[item.receiveTransport] : "",
                  _receiveStation: item.receiveStation ? StationKeys[item.receiveStation] : "",
                  _send: item.send ? ReceiveKeys[item.send] : "",
                  _sendTransport: item.sendTransport ? TransportKeys[item.sendTransport] : "",
                  _sendStation: item.sendStation ? StationKeys[item.sendStation] : "",
                  _room: item.room ? getItem(ROOM_TYPE_LIST, item.room) : '',
                }
              }) : []
          this.historyData = [...newData]
        } else {
          this.$message.error(msg || "服务异常，请联系客服")
        }
      }
    }
  },
  async mounted() {
    getQueryChannel().then(channelOptionsRes => {
      this.channelOptions = channelOptionsRes && channelOptionsRes.data ? channelOptionsRes.data.map(val => ({label: val, value: val})) : []
    }).catch(err => {
      this.channelOptions = []
    })
    getQueryChannelManager().then(channelManagerOptionsRes => {
      this.channelManagerOptions = channelManagerOptionsRes && channelManagerOptionsRes.data ? channelManagerOptionsRes.data.map(val => ({label: val, value: val})) : []
    }).catch(err => {
      this.channelManagerOptions = []
    })
    this.queryData(1)
  }
}
</script>

<style lang="less">
.clientInformationForm {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;

  .el-form {
    margin-top: 18px;
  }

  .el-form-item {
    margin-bottom: 14px;
  }

  > div, > .el-form {
    width: 100%;
  }

  .el-table th,
  .el-table td {
    padding: 5px 0;
  }

  .table-button {
    padding: 8px;
  }
}

.edit-dialog-wrapper {
  background: #fff;

  .el-dialog__body {
    padding: 14px 20px;
  }

  .edit-input {
    width: 217px;
  }
}
</style>
